import React from 'react';
import LinkComponent from '../../../components/common/Link';
import NewsForm from './newsForm';

const NewsCreation = () => {
  return (
    <div className="client-container">
      <div className="client__back-container">
        <LinkComponent title="Volver" url="/novedades" icon="arrow_back" />
      </div>
      <NewsForm mode="create" />
    </div>
  );
};

export default NewsCreation;
